// this file is generated by update_shopify_store_data.py at 2026-01-26 20:24:49.925471
var courses = [];